const requests = (state = {}, action) => {
	switch (action.type) {
		case 'REQUEST_LIST':
		case 'SET_REQUEST_DETAIL':
		case 'REJECTED_LIST':
		case 'SET_REJECTED_INFO':
		case 'DELETE_REQUEST_STATUS':
		case 'DELETE_REQUEST':
		case 'UPDATE_STATUS':
		case 'RESET_REJECTED_LIST':
			return { ...state, ...action.data };
		case 'RESET_REQUEST':
			return {};
		default:
			return state;
	}
};
export default requests;
